import { useQuery } from '@tanstack/vue-query'
import { Ref } from 'vue'
import { IAnalyticsPeriod } from 'xangle-charts'

import { explorerApi } from '~/api/client'
import { analyticsNetworkTransactionCountKey } from '~/api/service/query-keys.const'
import { IAnalyticsParam, IAnalyticsPeriod } from '~/types/analytics.type'
import { LineChartModel } from '~/types/model/analytics.model'

export const analyticsNetworkService = {
  useGetTransactionCount: (params: Ref<IAnalyticsParam>, isEnable?: Ref<boolean>) => {
    const getTransactionCount = async () => {
      const res = await explorerApi.analyticsController.getTrxCount({
        requestBody:{
          period: params.value.period === IAnalyticsPeriod.SELECTOR ? IAnalyticsPeriod.ALL : params.value.period,
          from: params.value.from || undefined,
          to: params.value.to || undefined,
        }
      })
      return new LineChartModel(res)
    }
    return useQuery([ ...analyticsNetworkTransactionCountKey, params ], getTransactionCount, {
      enabled: isEnable,
    })
  }
}